import Const from './const'

const DATA = Const.DATA

export function getKey(key) {
    return DATA.KEY_PREFIX + key;
}

export function get(key) {
    if (key) {
        key = getKey(key);
        return JSON.parse(window.localStorage.getItem(key));
    }
}
export function set(key, val) {
    if (key) {
        key = getKey(key);
        return window.localStorage.setItem(key, JSON.stringify(val));
    }
}
export function remove(key) {
    if (key) {
        key = getKey(key);
        return window.localStorage.removeItem(key);
    }
}

export function setToken(val) {
    set(DATA.KEY_TOKEN, val)
}
export function getToken() {
    return get(DATA.KEY_TOKEN);
}
export function removeToken() {
    remove(Const.DATA.KEY_TOKEN)
}

export function setUser(val) {
    set(DATA.KEY_USER, val)
}
export function getUser() {
    return get(DATA.KEY_USER);
}
export function removeUser() {
    remove(Const.DATA.KEY_USER)
}

export function setUserType(val) {
    set(DATA.KEY_USER_TYPE, val)
}
export function getUserType() {
    return get(DATA.KEY_USER_TYPE);
}
export function removeUserType() {
    remove(Const.DATA.KEY_USER_TYPE)
}


export function setAuthority(val) {
    set(Const.DATA.KEY_AUTHORITY, val)
}
export function getAuthority() {
    return get(Const.DATA.KEY_AUTHORITY)
}
export function removeAuthority() {
    remove(Const.DATA.KEY_AUTHORITY)
}


export function setLanguage(val) {
    set(Const.DATA.KEY_LANGUAGE, val)
}
export function getLanguage() {
    return get(Const.DATA.KEY_LANGUAGE)
}

export function clearUserData() {
    removeToken('');
    removeUserType('');
    removeAuthority('');
}
